package tta.destinigo.talktoastro.bottom_navigation

import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.stack.StackNavigation
import com.arkivanov.decompose.router.stack.bringToFront
import com.arkivanov.decompose.router.stack.childStack
import com.arkivanov.decompose.value.Value
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesComponent
import tta.destinigo.talktoastro.feature_home.presentation.HomeScreenTabComponent
import tta.destinigo.talktoastro.feature_home.presentation.event.HomePageEvent
import tta.destinigo.talktoastro.feature_post.PostScreenComponent
import tta.destinigo.talktoastro.feature_profile.component.FavoriteTabEvent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenEvent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenTabComponent
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreenComponent

// ViewModel for handling Back Press and Navigation
class BottomNavigationComponent(
    context: ComponentContext,
    private val homePageEvent: (HomePageEvent) -> Unit,
    private val moreScreenEvent: (MoreScreenEvent) -> Unit,
    private val favoriteTabEvent: (FavoriteTabEvent) -> Unit,
    private val onPostClick: (String) -> Unit,
    private val onRegisterButtonClick: (slug: String) -> Unit,
) : BottomNavComponent, ComponentContext by context {

    private val navigation = StackNavigation<Configuration>()
    private var _exitState = MutableStateFlow(false)
    val exitState = _exitState.asStateFlow()


    private val _stack =
        childStack(
            source = navigation,
            serializer = Configuration.serializer(),
            initialConfiguration = Configuration.HomeScreenConfig,
            childFactory = ::createChild,
            handleBackButton = true
        )

    override val stack: Value<ChildStack<*, BottomNavComponent.BottomTabChild>> = _stack

    private fun homeTab(context: ComponentContext) =
        BottomNavComponent.BottomTabChild.HomeScreenBottomTab(
            HomeScreenTabComponent(
                context = context,
                onHomePageEvent = homePageEvent
            )
        )

    private fun courseTab(context: ComponentContext) =
        BottomNavComponent.BottomTabChild.ExpertListBottomTab(
            CoursesComponent(
                context = context,
                onBackButtonClick = { handleBackPress() },
                onRegisterButtonClick = onRegisterButtonClick
            )
        )

    private fun postTab(context: ComponentContext) =
        BottomNavComponent.BottomTabChild.PostScreenBottomTab(
            PostScreenComponent(
                context = context,
                onBackClick = { handleBackPress() },
                onPostClick = onPostClick
            )
        )

    private fun favoriteTab(context: ComponentContext) =
        BottomNavComponent.BottomTabChild.FavoriteScreenBottomTab(
            FavoriteScreenComponent(
                context = context,
                onFavoriteTabEvent = {
                    if (it is FavoriteTabEvent.OnBackClick) {
                        handleBackPress()
                    } else {
                        favoriteTabEvent(it)
                    }
                }
            )
        )

    private fun moreTab(context: ComponentContext) =
        BottomNavComponent.BottomTabChild.MoreScreenBottomTab(
            MoreScreenTabComponent(
                context = context,
                onMoreScreenEvent = {
                    when (it) {
                        is MoreScreenEvent.onBackButtonClick,
                        is MoreScreenEvent.onSignOutButtonClick -> handleBackPress()

                        else -> moreScreenEvent(it)
                    }
                }
            )
        )

    private fun createChild(
        config: Configuration,
        ctx: ComponentContext
    ): BottomNavComponent.BottomTabChild {
        return when (config) {
            Configuration.CoursesPageConfig -> courseTab(context = ctx)
            Configuration.FavoriteScreenConfig -> favoriteTab(context = ctx)
            Configuration.HomeScreenConfig -> homeTab(ctx)
            Configuration.MoreScreeConfig -> moreTab(ctx)
            Configuration.PostScreenConfig -> postTab(ctx)
        }
    }

    override fun selectTab(index: Int) {
        val config = when (index) {
            0 -> Configuration.HomeScreenConfig
            1 -> Configuration.CoursesPageConfig
            2 -> Configuration.PostScreenConfig
            3 -> Configuration.FavoriteScreenConfig
            4 -> Configuration.MoreScreeConfig
            else -> Configuration.HomeScreenConfig
        }

        navigation.bringToFront(config)
//        if (stack.value.active.configuration != config) {
//            navigation.pushNew(config)
//        }else{
//            navigation.bringToFront(config)
//        }
    }

    private fun handleBackPress() {
        if (stack.value.active.configuration == Configuration.HomeScreenConfig) {
            _exitState.value = true
        } else {
            selectTab(0)
        }
    }


    @Serializable
    sealed class Configuration {
        @Serializable
        data object MoreScreeConfig : Configuration()

        @Serializable
        data object PostScreenConfig : Configuration()

        @Serializable
        data object FavoriteScreenConfig : Configuration()

        @Serializable
        data object CoursesPageConfig : Configuration()

        @Serializable
        data object HomeScreenConfig : Configuration()
    }
}


//class BottomNavigationComponent(
//    context: ComponentContext,
//    homePageEvent: (HomePageEvent) ->Unit,
//    moreScreenEvent: (MoreScreenEvent) -> Unit,
//    favoriteTabEvent: (FavoriteTabEvent) ->Unit,
//    private val onPostClick:(String) -> Unit,
//    private val onRegisterButtonClick: (slug: String) -> Unit,
//) :BottomNavComponent, ComponentContext by context {
//
//    private val navigation = PagesNavigation<BottomTab>()
//    private var _exitState = MutableStateFlow(false)
////    val exitState = _exitState.asStateFlow()
////    fun setDismissExitState(){
////        _exitState.value = false
////    }
//
//    override val pages: Value<ChildPages<*,BottomTabChild>> = childPages(
//        source = navigation,
//        serializer = BottomTab.serializer(),
//        initialPages = {
//            Pages(
//                items = listOf(
//                    BottomTab.HOME,
//                    BottomTab.COURSES,
//                    BottomTab.POST,
//                    BottomTab.FAVORITE,
//                    BottomTab.MORE,
//                ),
//                selectedIndex = 0 // Home is selected by default
//            )
//        }
//    ) { config, childComponentContext ->
//        bottomTabChild(
//            config,
//            childComponentContext,
//            homePageEvent,
//            favoriteTabEvent,
//            moreScreenEvent
//        )
//    }
//
//    private fun bottomTabChild(
//        config: BottomTab,
//        childComponentContext: ComponentContext,
//        homePageEvent: (HomePageEvent) -> Unit,
//        favoriteTabEvent: (FavoriteTabEvent) -> Unit,
//        moreScreenEvent: (MoreScreenEvent) -> Unit
//    ) = when (config) {
//        BottomTab.HOME -> BottomTabChild.HomeScreenTab(
//            HomeScreenTabComponent(childComponentContext,
//            onHomePageEvent = {
//                homePageEvent.invoke(it)
//            },
//        ))
//
//        BottomTab.COURSES -> BottomTabChild.ExpertListPage(
//            CoursesComponent(
//                childComponentContext,
//                onBackButtonClick = {
//                    handleBackPress()
//                },
//                onRegisterButtonClick = { slug ->
//                    onRegisterButtonClick.invoke(slug)
//                })
//        )
//
//        BottomTab.FAVORITE -> BottomTabChild.FavoriteScreenChild(
//            FavoriteScreenComponent(
//            childComponentContext,
//            onFavoriteTabEvent = { event ->
//                if (event is FavoriteTabEvent.OnBackClick){
//                    handleBackPress()
//                }else favoriteTabEvent.invoke(event)
//            }
//        ))
//
//        BottomTab.POST -> BottomTabChild.PostScreen(
//            PostScreenComponent(
//                childComponentContext,
//                onBackClick = {
//                    handleBackPress()
//                },
//                onPostClick = { id ->
//                    onPostClick.invoke(id)
//                })
//        )
//
//        BottomTab.MORE -> BottomTabChild.MoreScreenTab(MoreScreenTabComponent(childComponentContext,
//            onMoreScreenEvent = { event ->
//                if (event is MoreScreenEvent.onBackButtonClick) handleBackPress()
//                if (event is MoreScreenEvent.onSignOutButtonClick) handleBackPress()
//                else moreScreenEvent.invoke(event)
//            }
//        ))
//    }
//
//    override fun selectTab(index: Int) {
//        navigation.select(index)
//    }
//
//    /**
//     * Handle back press
//     */
//    fun handleBackPress() {
//        if (pages.value.selectedIndex == 0) {
//            // If on the Home tab, confirm exit
//           _exitState.value = true
//        } else {
//            // If on another tab, navigate to Home
//            selectTab(0)
//        }
//    }
//}
